import { ModalContext } from "app/app";
import { Fragment, useContext } from "react";
import loading from "./loading.gif";
import styles from "./styles.module.scss";

export function Loading() {
  const { modal } = useContext(ModalContext);

  return (
    <Fragment>
      {modal.name === "loading" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.image}>
              <img src={loading} width={40} height={40} alt="loading" />
            </div>
            <div className={styles.title}>{modal.data.title}</div>
            <div className={styles.description}>{modal.data.description}</div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
